"use client";
import { ToastContainer } from "react-toastify";
import { useState } from "react";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Image from "next/image";

const SurveyPage = () => {
	const [selectedOption, setSelectedOption] = useState("");

	const brochurePdfUrl = "/images/blog/brochure.pdf";
	const DATbrochurePdfUrl = "/images/blog/spanda_dat_brochure.pdf";
	const eliteUserGuide = "/images/blog/spanda_elite_user_guide.pdf"
	const proUserGuide = "/images/blog/spanda_pro_user_guide.pdf"
	const userGuidePdfUrl = "/images/blog/spanda_quick_reference_manual.pdf";
	const spandaAppQrCodeUrl = "/images/blog/QR_Code.png";

	const handleOptionChange = (selected) => {
		setSelectedOption(selected);
	};

	const handleDownloadClick = () => {
		if (selectedOption === "elite user guide") {
			window.open(eliteUserGuide, "_blank");
		} else if (selectedOption === "pro user guide") {
			window.open(proUserGuide, "_blank");
		} else if (selectedOption === "quick reference manual") {
			window.open(userGuidePdfUrl, "_blank");
		} else if (selectedOption === "brochure") {
			window.open(brochurePdfUrl, "_blank");
		}else if(selectedOption === "DAT brochure"){
			window.open(DATbrochurePdfUrl, "_blank");
		}
	};

	return (
		<>
			<Breadcrumb pageName="Downloads" />
			<section className="relative z-10 pb-16 pt-36 md:pb-20 lg:pb-28 lg:pt-[180px]">
				<div className="container">
					<div className="-mx-4 flex flex-wrap">
						<div className="w-full px-4">
							<div className="mx-auto max-w-[530px] text-center">
								<div className="mx-auto mb-9 text-center">
									<div className="mb-4">
										<label className="mb-2 block text-lg font-medium text-black dark:text-white">
											Select an option:
										</label>
										<div className="mb-4 flex items-center">
											<input
												type="radio"
												id="elite manual"
												name="selectedOption"
												value="elite manual"
												checked={selectedOption === "elite user guide"}
												onChange={() => handleOptionChange("elite user guide")}
												className="mr-2"
											/>
											<label htmlFor="elite manual">Spanda Elite User Guide</label>
										</div>
										<div className="mb-4 flex items-center">
											<input
												type="radio"
												id="pro manual"
												name="selectedOption"
												value="pro manual"
												checked={selectedOption === "pro user guide"}
												onChange={() => handleOptionChange("pro user guide")}
												className="mr-2"
											/>
											<label htmlFor="pro manual">Spanda Pro User Guide</label>
										</div>
										<div className="mb-4 flex items-center">
											<input
												type="radio"
												id="user guide"
												name="selectedOption"
												value="user guide"
												checked={selectedOption === "quick reference manual"}
												onChange={() => handleOptionChange("quick reference manual")}
												className="mr-2"
											/>
											<label htmlFor="user guide">Spanda Quick Reference Manual</label>
										</div>
										<div className="mb-4 flex items-center">
											<input
												type="radio"
												id="brochure"
												name="selectedOption"
												value="brochure"
												checked={selectedOption === "brochure"}
												onChange={() => handleOptionChange("brochure")}
												className="mr-2"
											/>
											<label htmlFor="brochure">Spanda Brochure</label>
										</div>
										<div className="mb-4 flex items-center">
											<input
												type="radio"
												id="spanda app"
												name="selectedOption"
												value="spanda app"
												checked={selectedOption === "DAT brochure"}
												onChange={() => handleOptionChange("DAT brochure")}
												className="mr-2"
											/>
											<label htmlFor="spanda app">Spanda DAT Brochure</label>
										</div>
										<div className="mb-4 flex items-center">
											<input
												type="radio"
												id="spanda app"
												name="selectedOption"
												value="spanda app"
												checked={selectedOption === "spanda app"}
												onChange={() => handleOptionChange("spanda app")}
												className="mr-2"
											/>
											<label htmlFor="spanda app">Spanda App</label>
										</div>
									</div>

									{/* Download button or QR code section */}
									{selectedOption && (
										<div className="mb-4">
											{selectedOption === "spanda app" ? (
												<div>
													<p className="mb-2">Scan the below QR code or search for Spanda on Play Store / App Store:</p>
													<Image
														src={spandaAppQrCodeUrl}
														alt="Spanda App QR Code"
														width={100}
														height={100}
														className="mx-auto w-1/2" // Adjust the width as needed
													/>
												</div>
											) : (

												<button
													onClick={handleDownloadClick}
													className="mt-4 rounded-md bg-saintiantblue px-8 py-3 text-base font-bold text-white shadow-signUp duration-300 hover:bg-white hover:text-saintiantblue md:px-9 lg:px-8 xl:px-9"
												>
													Download Spanda&nbsp;
													{selectedOption
														.split(" ") // Split the string into an array of words
														.map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
														.join(" ")} {/* Join the words back into a single string */}
												</button>
											)}
											<ToastContainer style={{ marginTop: "100px" }} />
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="absolute bottom-0 left-0 z-[-1] hidden sm:block"></div>
			</section>
		</>
	);
}; export default SurveyPage;
